import React from "react";
import me from "assets/img/me.jpg";
import { NewSection as Section, AboutContainer, Self, AboutMe } from "./style";
import { Title } from "components/shared";

export default function About() {
    return (
        <Section id="about">
            <Title>About Me</Title>
            <AboutContainer>
                <Self src={me} alt="Norberto Photo" loading="lazy"/>
                <AboutMe>
                    Hello! I am Nico, an aspiring web developer from the
                    Philippines. I am 19 years old and I am interested in
                    gaming, coding and music. It has been almost 6 months since
                    I started learning web development. Ever since I've started
                    , life has been so much fun and I've learned a lot and
                    beginning to love myself more. I hope this will turn me into
                    a better person and a better developer. Keep Safe and Keep
                    Coding!{" "}
                    <span role="img" aria-label="laptop and glasses">
                        💻😎
                    </span>
                </AboutMe>
            </AboutContainer>
        </Section>
    );
}
